const findLayoutItem = (state, itemId) =>
  state.items.display.layout.find(item => item.id === itemId);

const updateSelectedLayout = (state, itemId, isSelected) => {
  if (isSelected) {
    const foundLayoutItem = findLayoutItem(state, itemId);
    if (foundLayoutItem) {
      state.bulkAction.selected.layout.push(foundLayoutItem);
    }
  } else {
    state.bulkAction.selected.layout = state.bulkAction.selected.layout.filter(
      item => item.id !== itemId,
    );
  }
};

const updateSelectedThreads = (state, anchorItemId, isSelected) => {
  if (isSelected) {
    const foundLayoutItem = findLayoutItem(state, anchorItemId);
    delete state.bulkAction.selected.threads[anchorItemId];

    const selectedThread = foundLayoutItem?.itemCIDs.reduce(
      (acc, itemCID) => ({
        ...acc,
        [itemCID.streamItemId]: true,
        length: acc.length + 1,
      }),
      { length: 0 },
    );

    state.bulkAction.selected.threads[anchorItemId] = selectedThread;
  } else {
    delete state.bulkAction.selected.threads[anchorItemId];
  }
};

const handleAnchorItemSelection = (
  state,
  streamItemId,
  anchorItemId,
  isSelected,
) => {
  if (isSelected) {
    updateSelectedThreads(state, anchorItemId, isSelected);

    const isAlreadyAdded = state.bulkAction.selected.layout.some(
      item => item.id === streamItemId,
    );

    if (isAlreadyAdded) return;
  } else {
    delete state.bulkAction.selected.threads[anchorItemId];
  }

  updateSelectedLayout(state, anchorItemId, isSelected);
};

const handleThreadItemSelection = (
  state,
  streamItemId,
  anchorItemId,
  isSelected,
) => {
  if (isSelected) {
    if (!state.bulkAction.selected.threads[anchorItemId]) {
      state.bulkAction.selected.threads[anchorItemId] = { length: 0 };
    }

    const isAlreadyAdded = state.bulkAction.selected.layout.some(
      item => item.id === anchorItemId,
    );

    if (!isAlreadyAdded) {
      updateSelectedLayout(state, anchorItemId, isSelected);
    }

    state.bulkAction.selected.threads[anchorItemId][streamItemId] = true;
    state.bulkAction.selected.threads[anchorItemId].length += 1;
  } else {
    delete state.bulkAction.selected.threads[anchorItemId][streamItemId];
    state.bulkAction.selected.threads[anchorItemId].length -= 1;

    if (state.bulkAction.selected.threads[anchorItemId].length === 0) {
      delete state.bulkAction.selected.threads[anchorItemId];
      updateSelectedLayout(state, anchorItemId, isSelected);
    }
  }
};

const handleNonThreadItemSelection = (state, streamItemId, isSelected) => {
  if (isSelected) {
    state.bulkAction.selected.byId[streamItemId] = true;
  } else {
    delete state.bulkAction.selected.byId[streamItemId];
  }

  updateSelectedLayout(state, streamItemId, isSelected);
};

export const handleCheckBulkSelection = (
  state,
  { streamItemId, anchorItemId, isSelected },
) => {
  if (anchorItemId === streamItemId) {
    handleAnchorItemSelection(state, streamItemId, anchorItemId, isSelected);
  } else if (anchorItemId) {
    handleThreadItemSelection(state, streamItemId, anchorItemId, isSelected);
  } else {
    handleNonThreadItemSelection(state, streamItemId, isSelected);
  }
};
